import { FC } from 'react';

import { CustomerJobModel } from '../../../models/customer.model';
import { MessageCard } from '../../message-card/message-card';
import { formatDateTime } from '../../../utils/format-date';
import { Text } from '@servicetitan/anvil2';

interface CustomerJobProps {
    data: CustomerJobModel;
    className?: string;
    title: string;
}

export const CustomerJob: FC<CustomerJobProps> = ({ data, className, title }) => {
    return (
        <MessageCard flexDirection="column" className={className}>
            <Text variant="headline" el="h3" size="small">
                {title}
            </Text>

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Job ID
                </Text>
                <Text size="small">{data.job_id}</Text>
            </div>

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Job Type
                </Text>
                <Text size="small">{data.job_type}</Text>
            </div>

            <div>
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Date & Time
                </Text>
                <Text size="small">{formatDateTime(new Date(data.date_time))}</Text>
            </div>
        </MessageCard>
    );
};
